import type { CSSProperties } from 'react';
import guitarSvgRaw from '../assets/guitar.svg?raw';
import { prepareSvg } from './prepareSvg.ts';

const GUITAR_SVG = prepareSvg(guitarSvgRaw);

export interface GuitarMarkProps {
  className?: string;
  style?: CSSProperties;
}

export function GuitarMark({ className = '', style }: GuitarMarkProps) {
  return (
    <span
      className={`block ${className}`}
      style={style}
      aria-hidden
      dangerouslySetInnerHTML={{
        __html: GUITAR_SVG.replace(
          '<svg',
          '<svg preserveAspectRatio="xMidYMid meet" style="width:100%; height:100%; display:block;"',
        ),
      }}
    />
  );
}
